import { Button, Select, HStack, Text, IconButton } from "@chakra-ui/react";
import {
  paginationButtons,
  paginationSelect,
} from "../../../utils/styles/tableStyles";
import { FC } from "react";
import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { activeColor } from "../../../utils/colors";

interface PaginationProps {
  totalResults: number;
  pageSizeOptions: number[];
  pageSize: number;
  totalPages: number;
  setPageSize: (pageSize: number) => void;
  currentPage: number;
  handlePageChange: (newPage: number) => void;
}

const Pagination: FC<PaginationProps> = ({
  totalResults,
  pageSizeOptions,
  pageSize,
  totalPages,
  setPageSize,
  currentPage,
  handlePageChange,
}) => {
  const getDisplayedPages = () => {
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i,
    );
  };

  const displayedPages = getDisplayedPages();

  return (
    <HStack spacing={2}>
      <Text size="md" color={activeColor}>
        {totalResults === 0
          ? "Sem resultados"
          : `${(currentPage - 1) * pageSize + 1} a ${Math.min(
              currentPage * pageSize,
              totalResults,
            )} de ${totalResults} resultado(s)`}
      </Text>

      <HStack
        gap={0}
        borderRadius={4}
        overflow={"hidden"}
        border="1px solid #EDF2F7"
      >
        <IconButton
          aria-label="Primeira página"
          icon={<MdKeyboardDoubleArrowLeft size="20px" />}
          onClick={() => handlePageChange(1)}
          variant="secondary"
          isDisabled={currentPage === 1}
          sx={paginationButtons}
        />
        <IconButton
          aria-label="Página anterior"
          icon={<MdKeyboardArrowLeft size="20px" />}
          onClick={() => handlePageChange(currentPage - 1)}
          variant="secondary"
          isDisabled={currentPage === 1}
          borderLeft="1px solid #EDF2F7"
          sx={paginationButtons}
        />
        {displayedPages.map((page) => (
          <Button
            key={page}
            onClick={() => handlePageChange(page)}
            sx={paginationButtons}
            variant={page === currentPage ? "primary" : "secondary"}
          >
            {page}
          </Button>
        ))}
        <IconButton
          aria-label="Próxima página"
          icon={<MdKeyboardArrowRight size="20px" />}
          variant="secondary"
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
          borderRight="1px solid #EDF2F7"
          sx={paginationButtons}
        />
        <IconButton
          aria-label="Última página"
          icon={<MdKeyboardDoubleArrowRight size="20px" />}
          variant="secondary"
          onClick={() => handlePageChange(totalPages)}
          isDisabled={currentPage === totalPages}
          sx={paginationButtons}
        />
      </HStack>

      <Select
        value={pageSize}
        onChange={(e) => setPageSize(Number(e.target.value))}
        gap={1}
        {...paginationSelect}
      >
        {pageSizeOptions.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </Select>
    </HStack>
  );
};

export default Pagination;
